import React, {useEffect, useState} from 'react';
import Th_title from "../../../../../components/Th_title";
import {ContentCategory, UserType} from "../../../../../constant/CodeSpecNum";
import SelectedUserBadgeView from "../../../../../components/drawer/dropdownMenu/SelectedUserBadgeView";
import {ButtonBasic} from "../../../../../components/buttons/ButtonBasic";
import UserList from "../../../../../components/list/UserList";
import {useDispatch, useSelector} from "react-redux";
import {handleActiveError, handleActiveToast} from "../../../../../components/sonner/ToastBasic";
import {removeHandler, saveHandlers, selectHandlers} from "../../../../../api/handler/handlerService";
import {setSelectedUsers} from "../../../../../redux/slice/contentSlice";
import {apiLoading, refresh} from "../../../../../redux/slice/apiSlice";
import {useTranslation} from "react-i18next";
import SimmsDrawerArray from "../../../../../components/drawer/simms/SimmsDrawerArray";
import SimmsInputSearch from "../../../../../components/input/SimmsInputSearch";
import SimmsDrawerSearch from "../../../../../components/drawer/simms/SimmsDrawerSearch";
import {getUserListWithNoPages} from "../../../../../api/user/UserAccountService";

const ServiceCodeHandlerInfo = ({serviceCode}) => {
    const [handlers, setHandlers] = useState([]);

    const refreshStatus = useSelector(status => status.api.status);
    const selectedUsers = useSelector(state => state.content.selectedUsers);
    const dispatch = useDispatch();
    const {t} = useTranslation();

    useEffect(() => {
        handleCallHandlers();
    }, [refreshStatus]);

    const handleCallHandlers = async () => {
        if (serviceCode) {
            dispatch(apiLoading(true));
            const response = await selectHandlers({
               contentId: serviceCode.id, contentCategory: ContentCategory.SERVICE_CODE
            });
            if (response && response.status === 200) {
                dispatch(apiLoading(false));
                const users = response.data;
                setHandlers([...users]);
            } else {
                dispatch(apiLoading(false));
                handleActiveError({message: "서버에러"});
            }
        }
    }

    const handleSaveHandlers = async () => {
        if (!selectedUsers[UserType.users].length) {
            handleActiveError({message: "등록실패", description: "담당자를 선택해주세요."});
            return;
        }
        const users = selectedUsers[UserType.users].map(user => user.id);
        const response = await saveHandlers({
            contentId: serviceCode.id, handlerIds: users,
            contentCategory: ContentCategory.SERVICE_CODE
        });
        if (response && response.status === 200) {
            dispatch(setSelectedUsers([]));
            dispatch(refresh(!refreshStatus));
            handleActiveToast({message: t(`saved`), description: t(`savedWithoutDuplicatedData`)});
        }
    }

    const handleDeleteHandler = async (user) => {
        if (window.confirm("담당자를 삭제하시겠습니까?")) {
            const data = {
                handlerId: user.id, contentId: serviceCode.id, contentCategory: ContentCategory.SERVICE_CODE
            };
            const response = await removeHandler(data);
            if (response && response.status === 200) {
                dispatch(refresh(!refreshStatus));
                handleActiveToast({message: "삭제완료", description: "담당자가 삭제되었습니다."});
            }
        }
    }

    const handleSetUser = (selectedUser) => {
        const userIds = selectedUsers[UserType.users].map(u => u.id);
        if (!userIds.includes(selectedUser.id)) {
            dispatch(setSelectedUsers([...selectedUsers[UserType.users], {...selectedUser}]))
        }else{
            const newArr = selectedUsers[UserType.users].filter(e => e.id !== selectedUser.id);
            dispatch(setSelectedUsers([...newArr]))
        }
    }

    const allCheckHandlerAtDrawerArrayRedux = (bool, search, dispatch, api) => {
        if (bool) {
            api(search).then(r => {
                if (r.status === 200) {
                    dispatch(setSelectedUsers([...r.data])); // 배열만 dispatch
                }
            });
        } else {
            dispatch(setSelectedUsers([]));
        }
    };

    const thisPageCheckHandlerAtDrawerArrayRedux = (bool, obj, dispatch, selectedUsers) => {
        if (bool) {
            // 선택: 기존 selectedUsers + obj (id 기준 중복 제거)
            const nextArr = [
                ...selectedUsers[UserType.users],
                ...obj.filter(each => !selectedUsers[UserType.users].some(p => p.id === each.id))
            ];
            dispatch(setSelectedUsers(nextArr));
        } else {
            // 해제: obj에 포함된 id만 제거
            const nextArr = selectedUsers[UserType.users].filter(p => !obj.some(each => each.id === p.id));
            dispatch(setSelectedUsers(nextArr));
        }
    };

    return (
        <div className={"flex flex-col border p-5"}>
            <section className="section display-table">
                <table className="w-full create-table">
                    <tbody>
                    <tr>
                        <Th_title title={"처리담당자 선택"} colspan={3} className="fieldset-td">
                            <div className={'flex flex-col'}>
                                <div className={'flex gap-2 items-center'}>
                                    <ButtonBasic text={"저장"}
                                                 className={"h-[28px] bg-[#1c90fb] text-[white] px-[15px]"}
                                                 variant={"primary"}
                                                 onClick={handleSaveHandlers}/>
                                    <SimmsDrawerArray
                                        onChange={(value) => handleSetUser(value)}
                                        title={"처리담당자"}
                                        data={selectedUsers[UserType.users]}
                                        uniqueKey={UserType.approvers}
                                        entity={"userAccount"} auth
                                        all={(bool, search) => allCheckHandlerAtDrawerArrayRedux(bool, search, dispatch, getUserListWithNoPages)}
                                        page={(bool, handlers) => thisPageCheckHandlerAtDrawerArrayRedux(bool, handlers, dispatch, selectedUsers)}
                                    >

                                        <SimmsInputSearch type={'TEXT'} placeHolder={"사용자명"} />
                                        <SimmsDrawerSearch showLabel title={'부서'} entity={'department'} target={'department'} recursive />
                                        <SimmsDrawerSearch showLabel title={'업체'} entity={'company'} target={'company'} />
                                    </SimmsDrawerArray>
                                </div>
                                {selectedUsers[UserType.users].length > 0 &&
                                    <div className={'mt-2'}>
                                        <SelectedUserBadgeView users={selectedUsers[UserType.users]}
                                                               reducer={setSelectedUsers}/>
                                    </div>
                                }
                            </div>
                        </Th_title>
                    </tr>
                    <tr>
                        <th className="fieldset-th">
                            <div className={"flex justify-between"}>
                                <span className="input-label">처리담당자</span>
                            </div>
                        </th>
                        <td colSpan={1} className="fieldset-td">
                            {handlers.length > 0 && <UserList users={handlers} deleteUser={handleDeleteHandler}/>}
                            {handlers.length === 0 && <div className={'my-2'}>등록된 처리담당자가 없습니다.</div>}
                        </td>
                    </tr>
                    </tbody>
                </table>
            </section>
        </div>
    );
};

export default ServiceCodeHandlerInfo;